import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Image as ImageIcon, Check } from 'lucide-react';
export function Nails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-570">
      <div className="container mx-auto px-6 md:px-12" data-id="element-571">
        {/* HERO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-20" data-id="element-572">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-573">
            Манікюр і педикюр
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed" data-id="element-574">
            Комплексний догляд за вашими нігтями — від класичного гігієнічного
            манікюру до нарощування та дизайну.
          </p>
        </motion.div>

        {/* SERVICE CARDS */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid md:grid-cols-2 gap-8 mb-16 max-w-4xl mx-auto" data-id="element-575">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-[2rem] border border-line shadow-sm" data-id="element-576">
            <h3 className="text-2xl font-semibold text-ink mb-6 pb-4 border-b border-line" data-id="element-577">
              Манікюр
            </h3>
            <ul className="space-y-4" data-id="element-578">
              {[{
              name: 'Гігієнічний манікюр',
              price: '200 грн'
            }, {
              name: 'Манікюр + гель-лак',
              price: '350 грн'
            }, {
              name: 'Нарощування',
              price: '500 грн'
            }, {
              name: 'Корекція одного нігтя',
              price: '40 грн'
            }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-579">
                  <span className="text-muted" data-id="element-580">{item.name}</span>
                  <span className="font-semibold text-ink" data-id="element-581">{item.price}</span>
                </li>)}
            </ul>
          </div>

          {/* Card 2 */}
          <div className="bg-white p-8 rounded-[2rem] border border-line shadow-sm h-fit" data-id="element-582">
            <h3 className="text-2xl font-semibold text-ink mb-6 pb-4 border-b border-line" data-id="element-583">
              Педикюр
            </h3>
            <ul className="space-y-4" data-id="element-584">
              {[{
              name: 'Без покриття',
              price: '300 грн'
            }, {
              name: 'З покриттям',
              price: '450 грн'
            }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-585">
                  <span className="text-muted" data-id="element-586">{item.name}</span>
                  <span className="font-semibold text-ink" data-id="element-587">{item.price}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* HIGHLIGHTS */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-4xl mx-auto mb-24" data-id="element-588">
          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-589">
            <ul className="space-y-4" data-id="element-590">
              {['Апаратний та комбінований манікюр', 'Стерильні інструменти', 'Якісні матеріали провідних брендів'].map((item, i) => <li key={i} className="flex items-start" data-id="element-591">
                  <div className="bg-white p-1 rounded-full border border-line mr-4 mt-0.5 shadow-sm" data-id="element-592">
                    <Check className="text-ink flex-shrink-0" size={14} strokeWidth={3} data-id="element-593" />
                  </div>
                  <span className="text-ink font-medium text-base" data-id="element-594">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* PORTFOLIO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-24" data-id="element-595">
          <div className="text-center mb-12" data-id="element-596">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-597">
              Мої роботи
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-598"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-599">
            {[1, 2, 3].map(i => <div key={i} className="aspect-[3/4] bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm" data-id="element-600">
                <div className="text-center flex flex-col items-center" data-id="element-601">
                  <ImageIcon className="text-muted mb-3" size={32} strokeWidth={1.5} data-id="element-602" />
                  <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-603">
                    Фото роботи
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-md mx-auto flex flex-col gap-4" data-id="element-604">
          <a href="/#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-605">
            Записатися
          </a>
          <Link to="/#services" className="w-full py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-606">
            До всіх послуг
          </Link>
        </motion.div>
      </div>
    </main>;
}